<template>
    <div>
        <ds-table-grid
            ref="table"
            :data="viewedUrls"
            align="center"
            data-qa="web-profile-list-table"
            class="web-profile-list-table"
        >
            <ds-table-grid-column
                label="View Date/Time"
                width="120"
                prop="viewDate"
            />

            <ds-table-grid-column
                label="URL"
                width="300"
                prop="pageUrl"
            >
                <template slot-scope="item">
                    <ds-link
                        :href="item.pageUrl"
                        target="_blank"
                        class="url-length"
                    >
                        {{ item.pageUrl }}
                    </ds-link>
                </template>
            </ds-table-grid-column>

            <ds-table-grid-column
                label="View Length"
                width="80"
                prop="viewLength"
            >
                <template slot-scope="item">
                    <span data-qa="viewed-time">
                        {{ secondsToHms(item.viewLength) }}
                    </span>
                </template>
            </ds-table-grid-column>
        </ds-table-grid>
    </div>
</template>

<script>
export default {
    props: {
        viewedUrls: Array,
    },

    methods: {
        secondsToHms(sec) {
            let result = '';

            if (sec > 0) {
                const h = Math.floor(sec / 3600);
                const m = Math.floor(sec % 3600 / 60);
                const s = Math.floor(sec % 3600 % 60);

                const hours = h > 0 ? `${h}h ` : '';
                const minutes = m > 0 ? `${m}m ` : '';
                const seconds = s > 0 ? `${s}s ` : '';

                result = hours + minutes + seconds;
            } else {
                result = '<1s';
            }

            return result;
        },
    },
};
</script>

<style lang="scss" scoped>
.url-length {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    color: $color-primary !important;
}
</style>
